export default __webpack_public_path__ + "static/media/warning--texts--g3.14da2898.png";